export const promptTemplates = {
  financial: [
    "Give me a tip for saving money this month",
    "How can I be more mindful with my spending?",
    "What's a good budgeting strategy?",
  ],
  motivational: [
    "Give me motivation to stick to my financial goals",
    "Write an affirmation about financial freedom",
    "Inspire me to be disciplined with money",
  ],
  advice: [
    "How do I stop impulse buying?",
    "What should I track in my expenses?",
    "Give me advice on reducing regret purchases",
  ],
} as const;